module.exports = __webpack_public_path__ + "media/country_flags/ua-7cccc0ed.png";